import type { CoreFetch } from '~/types/CoreFetch'
import type InfluencerInteraction from '~/types/influencerInteraction'

export function provideFetchBandCuratorHistory(coreFetch: CoreFetch) {
  return function (influencerId: number): Promise<InfluencerInteraction[]> {
    return coreFetch.$get<InfluencerInteraction[]>(
      `/band/history/?influencer_id=${influencerId}`,
    )
  }
}
